import { gql } from '@apollo/client'

export const FIND_MANY_LOGIN_ATTEMPT = gql`
  query FindManyLoginAttempt(
    $where: LoginAttemptWhereInput
    $orderBy: [LoginAttemptOrderByWithRelationInput!]
    $cursor: LoginAttemptWhereUniqueInput
    $take: Int
    $skip: Int
    $distinct: [LoginAttemptScalarFieldEnum!]
  ) {
    findManyLoginAttempt(
      where: $where
      orderBy: $orderBy
      cursor: $cursor
      take: $take
      skip: $skip
      distinct: $distinct
    ) {
      id
      createdAt
      updatedAt
      attempt_type
      status
      email
      ip_address
      user_agent
      customer_id
      customer_account_id
      manager_id
      expires_at
      blocked_until
      error_message
      failure_reason
      metadata
    }
  }
`

export const FIND_MANY_LOGIN_ATTEMPT_COUNT = gql`
  query FindManyLoginAttemptCount(
    $where: LoginAttemptWhereInput
    $orderBy: [LoginAttemptOrderByWithRelationInput!]
    $cursor: LoginAttemptWhereUniqueInput
    $take: Int
    $skip: Int
    $distinct: [LoginAttemptScalarFieldEnum!]
  ) {
    findManyLoginAttemptCount(
      where: $where
      orderBy: $orderBy
      cursor: $cursor
      take: $take
      skip: $skip
      distinct: $distinct
    )
  }
`
